export default __webpack_public_path__ + "08fd02136b5ceba6a1bf4d672a067ca8.png";